var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getShiftPositionDetailsFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
export const getShiftPositionDetailsKey = 'getShiftPositionDetails';
export const useShiftPositionDetails = (params) => {
    const getShiftPositionDetailsPlatformFn = useTypedPlatformFunction(getShiftPositionDetailsFunctionDef);
    const getShiftPositionDetails = (params) => __awaiter(void 0, void 0, void 0, function* () {
        return getShiftPositionDetailsPlatformFn(params).catch(handleErrorSnackbar);
    });
    const { data: shiftPositionDetails, isLoading } = useSWR([getShiftPositionDetailsKey, params], ([, params]) => getShiftPositionDetails(params), defaultFetcherOptions);
    return {
        shiftPositionDetails,
        isLoading,
    };
};
